import Marquee from "react-fast-marquee";
import { ArrowUpRight } from "lucide-react";
import Reveal, { Eyebrow } from "@/components/Reveal";
import { WHATSAPP_URL } from "@/lib/site";

const words = ["Certidão circunstanciada", "Quitação eleitoral", "Passaporte", "Consulado", "Regularização"];

export default function FinalCta() {
  return (
    <section className="relative border-t border-ink/10 overflow-hidden" data-testid="final-cta-section">
      <div className="py-24 md:py-36 text-center relative">
        <span className="pointer-events-none select-none absolute inset-x-0 top-1/2 -translate-y-1/2 font-serif italic font-bold text-[22vw] leading-none outline-text text-center">
          Pronto
        </span>
        <div className="relative max-w-7xl mx-auto px-6 md:px-12">
          <Reveal>
            <Eyebrow>Pronto para resolver</Eyebrow>
            <h2 className="font-serif font-semibold text-4xl md:text-6xl tracking-tight text-ink mt-5 max-w-2xl mx-auto leading-[1.08]">
              Fale com a gente antes de arriscar <em className="italic text-brass">sozinho</em>.
            </h2>
            <div className="mt-11">
              <a
                data-testid="final-whatsapp-cta"
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="group inline-flex items-center gap-2.5 rounded-full bg-ink px-9 py-4 font-mono text-[12.5px] font-bold uppercase tracking-[0.08em] text-paper shadow-[0_14px_30px_-12px_rgba(22,34,59,0.5)] transition-all duration-300 hover:bg-brass hover:text-ink hover:-translate-y-0.5"
              >
                Falar no WhatsApp
                <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </a>
            </div>
          </Reveal>
        </div>
      </div>
      <div className="border-t border-ink/10 py-5">
        <Marquee speed={20} gradient={false}>
          {[...words, ...words, ...words].map((w, i) => (
            <span key={i} className="mx-8 flex items-center gap-8">
              <span className="font-serif italic text-2xl md:text-3xl text-ink/30">{w}</span>
              <span className="w-1.5 h-1.5 rounded-full bg-brass/50 inline-block" />
            </span>
          ))}
        </Marquee>
      </div>
    </section>
  );
}
